import type { ReactElement } from "react";

const resolveConfinedTitle = (pageTitle: string | ReactElement, pageLabel?: string): string => {
	if (typeof pageTitle === "string" && pageTitle.trim().length > 0) return pageTitle;
	return pageLabel ?? "";
};

export default resolveConfinedTitle;
